export enum HandlingOriginEnum {

  Supplier = 1,
  Location = 0

}
